const ID_TOKEN_KEY = 'id_token';
const ACCESS_TOKEN_KEY = 'access_token';

export { ID_TOKEN_KEY, ACCESS_TOKEN_KEY };
